import { ColDef } from 'ag-grid-community'
import { AssetNameCell, cellWarningStyle, PercentageFormatter, Table } from 'components/core-v2'

import { MaxDrawdownReportEntry } from '@/api'

export interface DrawdownTableProps {
  data: MaxDrawdownReportEntry[]
}

const cellStyle = params => {
  if (params.value < params.node.data.gapPutStrike) {
    return cellWarningStyle
  }
}

const BASE_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'ISIN',
    field: 'itemId',
    minWidth: 180
  },
  {
    headerName: '1D',
    field: 'maxDrawdown1D',
    minWidth: 120,
    flex: 0.15,
    valueFormatter: PercentageFormatter,
    cellStyle
  },
  {
    headerName: '3D',
    field: 'maxDrawdown3D',
    minWidth: 120,
    flex: 0.15,
    valueFormatter: PercentageFormatter,
    cellStyle
  },
  {
    headerName: '1W',
    field: 'maxDrawdown1W',
    minWidth: 120,
    flex: 0.15,
    valueFormatter: PercentageFormatter,
    cellStyle
  },
  {
    headerName: '1M',
    field: 'maxDrawdown1M',
    minWidth: 120,
    flex: 0.15,
    valueFormatter: PercentageFormatter,
    cellStyle
  },
  {
    headerName: '1Y',
    field: 'maxDrawdown1Y',
    minWidth: 120,
    flex: 0.15,
    valueFormatter: PercentageFormatter,
    cellStyle
  },
  {
    headerName: 'Gap Strike',
    field: 'gapPutStrike',
    minWidth: 120,
    flex: 0.15,
    valueFormatter: PercentageFormatter
  }
]

const ASSET_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'itemName',
    minWidth: 290
  },
  ...BASE_COLUMN_DEFS
]
const PORTFOLIO_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'itemName',
    minWidth: 290,
    cellRenderer: AssetNameCell
  },
  ...BASE_COLUMN_DEFS
]

const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}

export const AssetDrawdownTable = ({ data }: DrawdownTableProps) => (
  <Table
    agGridProps={{
      columnDefs: ASSET_COLUMN_DEFS,
      defaultColDef: DEFAULT_COLUMN_OPTIONS,
      headerHeight: 60,
      rowData: data,
      rowHeight: 44
    }}
    height="600px"
  />
)

export const PortfolioDrawdownTable = ({ data }: DrawdownTableProps) => {
  const rowData = data.map(row => ({ ...row, assetId: row.itemId, name: row.itemName }))

  return (
    <Table
      agGridProps={{
        columnDefs: PORTFOLIO_COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44
      }}
      height="600px"
    />
  )
}
